import type { PositionDescription } from './types';

/** The API stores `{ context, responsibilities[], mustHave[], niceToHave[], notes }`; fill the gaps. */
export function normalizeDescription(
  value: Partial<PositionDescription> | null | undefined,
): PositionDescription {
  return {
    context: value?.context ?? '',
    responsibilities: value?.responsibilities ?? [],
    mustHave: value?.mustHave ?? [],
    niceToHave: value?.niceToHave ?? [],
    notes: value?.notes ?? '',
  };
}
